<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<style>
  @import "./style/reset.less";
</style>

<script>
export default {
  name: 'App',
  mounted() {
    function checkIE() {
      return (
        "-ms-scroll-limit" in document.documentElement.style &&
        "-ms-ime-align" in document.documentElement.style
      );
    }
    if (checkIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue